import dayjs from 'dayjs';
import { required, requiredIf, helpers } from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';

const containNoWeekendDays = helpers.withParams(
    { type: 'containNoWeekendDays' },
    function() {
        let from = dayjs(this.formData.startDate);
        const to = dayjs(this.formData.endDate);

        while (from.isBefore(to) > 0) {
            const dayOfWeek = from.day();

            if (dayOfWeek === 0 || dayOfWeek === 6) {
                return false;
            }

            from = from.add(1, 'day');
        }

        return true;
    }
);

const containNoHolidays = helpers.withParams(
    { type: 'containNoHolidays' },
    function() {
        let from = dayjs(this.formData.startDate);
        const to = dayjs(this.formData.endDate);

        while (from.isBefore(to) > 0) {
            const dayOfMonth = from.date();

            if (this.holidayDates.includes(dayOfMonth)) {
                return false;
            }

            from = from.add(1, 'day');
        }

        return true;
    }
);

const endDateIsAfterStartDate = helpers.withParams(
    { type: 'endDateIsAfterStartDate' },
    function() {
        return !dayjs(this.formData.endDate).isBefore(this.formData.startDate);
    }
);

export default {
    mixins: [abstractValidatorMixin],
    data() {
        return {
            serverErrors: {
                userId: [],
                startDate: [],
                endDate: []
            }
        };
    },
    validations: {
        formData: {
            userId: {
                required: requiredIf(function() {
                    return this.isAdmin;
                })
            },
            startDate: {
                required,
                containNoWeekendDays,
                containNoHolidays
            },
            endDate: {
                required,
                containNoWeekendDays,
                containNoHolidays,
                endDateIsAfterStartDate
            }
        }
    },
    computed: {
        userIdErrors() {
            return this.checkErrors('userId');
        },
        startDateErrors() {
            return this.checkErrors('startDate');
        },
        endDateErrors() {
            return this.checkErrors('endDate');
        }
    }
};
